import * as e from "react";
import c from "../lib/IconBase.es.js";
import t from "../defs/Checkerboard.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(c, { ref: a, ...r, weights: t }));
o.displayName = "CheckerboardIcon";
const n = o;
export {
  n as Checkerboard,
  o as CheckerboardIcon
};
